import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { styled } from '@mui/material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      padding: '2rem',
      justiyContent: 'center',
      alignItems: 'center',
    },
  })
);

export default useStyles;

export const CreateButton = styled('button')(
  ({ backgroundColor }: { backgroundColor: string }) => ({
    color: '#fff',
    backgroundColor,
    borderRadius: '3px',
    display: 'block',
    minWidth: '250px',
    padding: '0.5rem 0',
  })
);
